import { Component, Inject } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { CompensationBaseBonus } from '../../core/compensation-base-bonus.model';
import { TranslationKeyMap } from '../../scorecard.i18n';

@Component({
    selector: '[cmpsCompBonusGridModal]',
    templateUrl: './comp-bonus-grid-modal.component.html',
    host: {
        class: 'comp-bonus-grid-modal',
    },
})
export class ScCompBonusGridModalComponent {
    /** @private */ _i18n = TranslationKeyMap;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            ScCompBonusGridModalComponent,
            any
        >,
        /** @private */ @Inject(CMPS_DIALOG_DATA)
        readonly _data: CompensationBaseBonus[],
    ) {}
}
